import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'

export default function useTagsList() {
  const MODULE_NAME = 'tags'
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      lang: selectedLang,
      user: resource.userId,
      tagLink: { name: `pages-${MODULE_NAME}-edit`, params: { id: resource._id, lang: selectedLang } },
    }
  }

  const ENDPOINT = 'tags'

  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), sortable: true, type: 'truncate-text', linkKey: 'tagLink',
    },
    {
      key: 'user', label: i18n.t('general.creator'), type: 'user', sortable: false,
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    tableColumns,
    convertResource,
  }
}
